import { del } from '../../common/axiosClient';
import { API } from '../../common/constants/urls';

export const deleteProject = async (projectNumber: string) => {
  const response = await del(`${API.DELETE_PROJECT}/${projectNumber}`);
  if (response.status === 200) {
    return response;
  } else {
    console.log('error: ', response.status);
    throw new Error(response.statusText); // Or a custom error message
  }
};
export const deleteReport = async (reportId: string) => {
  try {
    return await del(`${API.CA_REPORT}/${reportId}`);
  } catch (error) {
    console.log('error: ', error);
    // throw new Error(response.statusText); // Or a custom error message
  }
};
export const deleteNoteFromReport = async (reportId: string, noteId: string) => {
  return await del(`${API.CA_REPORT}/${reportId}/notes/${noteId}`);
};
